<template>
	<div
		class="product-details"
		:class="{
			'full-height': !acceptOnlineOrder || hasProductDetailsError,
			stuck: isStuck,
			'is-loading': !isLoaded,
			'without-mods':
				!productModifiers.forcedModCategories ||
				!productModifiers.forcedModCategories.length
		}"
	>
		<template v-if="isLoaded">
			<div
				v-if="isLoaded"
				class="product-details__top-panel"
				:class="{ active: isScrollingThroughRow }"
			>
				<div class="product-details-title product-details-title--description">
					{{ productDetails.name }}
				</div>
				<span class="close-button" @click="hideProductDetails" />
			</div>
			<template v-if="!hasProductDetailsError">
				<div class="product-details-holder" ref="product-details-holder">
					<div
						class="product-details-header-wrap"
						ref="product-details-header-wrap"
					>
						<div class="product-details-header--container">
							<product-details-header
								v-if="hasImages"
								:product-details="productDetails"
								:product-id="cartItemId"
							/>

							<div
								class="product-details-sub-header"
								:class="{ 'has-no-image': !hasImages }"
								:style="{
									'margin-top': hasImages ? `-${subHeaderHeightInPx}px` : 0
								}"
								ref="product-details-sub-header"
							>
								<div
									v-if="productDetails.gallery.length > 1"
									class="product-details-swiper-pagination__holder"
								>
									<div
										class="product-details-swiper-pagination swiper-pagination"
									></div>
								</div>
								<div
									ref="product-details-row"
									class="product-details-row"
									:class="{
										'product-details-row--without-images': !hasImages
									}"
								>
									<span
										class="product-details-title product-details-title--description"
									>
										{{ productDetails.name }}
									</span>
								</div>

								<div class="product-price">
									<div class="d-flex flex-align-center">
										<div class="d-flex flex-align-center">
											<template
												v-if="
													productDetails.promotedPrice !== null &&
														productDetails.promotedPrice !== undefined
												"
											>
												<span class="product-details-price">
													<formatted-price
														:price="productDetails.promotedPrice"
														decimal-height="70"
													/>
												</span>
												<span
													v-if="
														isPromotedPriceLess(
															productDetails.promotedPrice,
															productDetails.price
														)
													"
													class="product-details-alt-price"
												>
													<formatted-price
														class="alt-price"
														:price="productDetails.price"
														decimal-height="70"
													/>
												</span>
											</template>

											<span v-else class="product-details-price">
												<formatted-price
													:price="productDetails.price"
													decimal-height="70"
												/>
											</span>
										</div>
										<div>
											<span
												v-if="isEightySixProduct"
												class="product-badge sold-badge"
											>
												Sold Out
											</span>
										</div>
									</div>
								</div>

								<div class="product-bages">
									<span
										v-if="
											productDetails.trending &&
												productDetails.trendingCategoryRating &&
												isTrending
										"
										class="products-priority"
									>
										{{ productDetails.trendingCategoryRating }}
									</span>
									<span v-if="productDetails.new" class="product-badge mb-10">
										New
									</span>
									<span
										v-if="productDetails.favorite"
										class="product-badge favorites-badge mb-10"
									>
										Staff Favorite
									</span>
									<span
										v-if="limitedQuantity || almostGone"
										class="product-details-almost-gone-status mb-10"
									>
										<span class="product-badge">
											{{ almostGone ? 'Almost Gone' : 'Limited Qty' }}
										</span>
									</span>
								</div>
								<div
									v-if="productDetails.description"
									class="product-details-description"
								>
									<p>
										{{ productDetails.description }}
									</p>
								</div>
							</div>
						</div>
					</div>
					<!--					Removed due to requirements-->
					<!--					<switcher-->
					<!--						v-if="isInVenue && acceptOnlineOrder && !isEightySixProduct"-->
					<!--						class="mb-10"-->
					<!--						:disabled="!isForHereOrderingAvailable || !isToGoOrderingAvailable"-->
					<!--						:switcher-labels="$options.PRODUCT_TYPES_LIST"-->
					<!--						:active-index="orderType - 1"-->
					<!--						@switch-active-index="orderType = $event + 1"-->
					<!--					/>-->

					<div class="product-details-frame" ref="product-details-frame">
						<edit-product-mods
							v-if="acceptOnlineOrder"
							:class="{ disabled: isEightySixProduct }"
							ref="forced-mods-form"
							:accept-item-request="acceptItemRequest"
							:accept-online-order="acceptOnlineOrder"
							:forced-mod-categories="productModifiers.forcedModCategories"
							:product-in-cart="cartItem"
							:product-notice="productNotice"
							:is-editing="true"
							:validate="validateForcedMods"
							:show-errors="showForcedModsErrors"
							@change="changeForcedMods"
							@change-product-notice="changeProductNotice"
							@set-is-valid="setIsValidForcedMods"
						/>
					</div>
				</div>

				<add-to-cart
					v-if="acceptOnlineOrder"
					:class="{ disabled: isEightySixProduct }"
					:products-count="productsCount"
					:max-products-count="maxProductsCount"
					:products-amount="productsAmount"
					:is-loading="isProductUpdating"
					:is-editing="true"
					:is-valid="isForcedModsValid"
					@change-products-count="changeProductsCount"
					@add-to-cart="callUpdateProduct"
				/>
			</template>
			<product-details-not-found v-else @get-product-details="getData" />

			<loader v-if="isLoading || isProductUpdating" />
			<portal to="modal">
				<transition name="fade">
					<unavailability-modal
						v-if="isUnAvailableModalOpen"
						v-bind="unAvailableModalProps"
						@on-action="onModalAction"
						@close="closeUnAvailableModal"
					/>
				</transition>
			</portal>
		</template>
		<loader v-else />
	</div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

import ProductDetailsHeader from '../ProductDetailsHeader'
import EditProductMods from './EditProductMods'
import ProductDetailsNotFound from '../ProductDetailsNotFound'
import AddToCart from '../AddToCart'
import Loader from '@/components/Loaders/Loader.vue'
// import Switcher from '@/components/Switcher.vue'
import UnavailabilityModal from '@/components/modals/UnavailabilityModal.vue'
import FormattedPrice from '@/components/FormattedPrice.vue'

import routerMixin from '@/mixins/routerMixin'

import {
	REMAINING_STATUS,
	MAX_PRODUCTS_COUNT,
	PRODUCT_TYPES_LIST,
	PRODUCT_ORDER_TYPES,
	PRODUCT_ORDER_TYPES_NAMES,
	DEFAULT_UNAVAILABLE_MODAL_PROPS,
	ALL_ORDER_TYPES_NAMES,
	ORDERS_ACTIONS_TEXT_LIST,
	UPDATE_CART_ITEM_400_VALIDATION_CODES,
	UPDATE_CART_ITEM_404_VALIDATION_CODES
} from '@/constants'
import { getValidationCode } from '@/utils/helpers'

export default {
	name: 'EditProductDetails',

	mixins: [routerMixin],

	components: {
		UnavailabilityModal,
		// Switcher,
		ProductDetailsHeader,
		EditProductMods,
		ProductDetailsNotFound,
		AddToCart,
		Loader,
		FormattedPrice
	},

	PRODUCT_TYPES_LIST,

	data() {
		return {
			productsCount: 1,
			isProductUpdating: false,
			hasProductDetailsError: false,
			selectedForcedMods: [],
			productNotice: '',
			validateForcedMods: 0,
			invalidForcedModsCategoryIds: [],
			showForcedModsErrors: false,
			isStuck: false,
			isLoaded: false,
			orderType: PRODUCT_ORDER_TYPES.forHere,
			isUnAvailableModalOpen: false,
			unAvailableModalProps: { ...DEFAULT_UNAVAILABLE_MODAL_PROPS },

			isScrollingThroughRow: false,
			subHeaderHeightInPx: 0
		}
	},

	async mounted() {
		await this.getData()
		this.setAllOrderingAvailable()

		this.init()

		this.setOrderType()

		this.isLoaded = true
		this.$emit('product-loaded')

		this.$nextTick(() => {
			this.triggerForceModeValidation()
			this.showForcedModsErrors = true

			const productDetailsHolder = this.$refs['product-details-holder']

			if (productDetailsHolder) {
				productDetailsHolder.addEventListener('scroll', this.handleScroll)
			}

			window.addEventListener('resize', this.handleResize)

			this.handleResize()
		})
	},

	beforeDestroy() {
		this.reset()

		const productDetailsHolder = this.$refs['product-details-holder']

		if (productDetailsHolder) {
			this.removeStuck()
			productDetailsHolder.removeEventListener('scroll', this.handleScroll)
		}

		window.removeEventListener('resize', this.handleResize)
	},

	computed: {
		...mapGetters('cart', [
			'isCartOrderTypeInVenue',
			'isToGoProductsIncludesFood'
		]),
		...mapState('products', [
			'productDetails',
			'productModifiers',
			'isProductDetailsLoading',
			'isProductModifiersLoading'
		]),
		...mapState('venue', [
			'venueInfo',
			'isToGoOrderingAvailable',
			'isPickUpOrderingAvailable',
			'isForHereOrderingAvailable',
			'pickUpHours',
			'toGoHours',
			'forHereHours'
		]),
		...mapState('cart', {
			cartId: 'id',
			cartItems: 'cartItems',
			isInVenue: 'isInVenue',
			lastProductOrderType: 'lastProductOrderType',
			includeUtensils: 'includeUtensils'
		}),

		limitedQuantity() {
			return (
				this.productDetails.remainingProductStatus ===
				this.remainingStatus.LIMITED_QUANTITY
			)
		},

		almostGone() {
			return (
				this.productDetails.remainingProductStatus ===
				this.remainingStatus.ALMOST_GONE
			)
		},

		acceptToGo() {
			return this.venueInfo.acceptToGo
		},

		acceptForHere() {
			return this.venueInfo.acceptForHere
		},

		acceptItemRequest() {
			return this.isLoaded && this.productDetails.acceptProductNote
		},

		remainingStatus() {
			return REMAINING_STATUS
		},

		maxProductsCount() {
			return MAX_PRODUCTS_COUNT
		},

		isEightySixProduct() {
			const { remainingProductStatus } = this.productDetails
			const { EIGHTY_SIX, LIMIT_ALMOST_REACHED } = this.remainingStatus

			return [EIGHTY_SIX, LIMIT_ALMOST_REACHED].includes(remainingProductStatus)
		},

		isLoading() {
			return this.isProductDetailsLoading || this.isProductModifiersLoading
		},

		isForcedModsValid() {
			return !this.invalidForcedModsCategoryIds.length
		},

		productCategory() {
			return this.productDetails.category && this.productDetails.category.name
		},

		cartItemId() {
			return this.$route.query.productId
		},

		cartItem() {
			return this.cartItems.find(item => item.id === this.cartItemId) || {}
		},

		cartItemRemoteProductId() {
			return this.cartItem?.remoteProductId
		},

		hasImages() {
			return !!this.productDetails.gallery.length
		},

		isTrending() {
			return +this.$route.query.trending
		},

		productInCartCount() {
			return this.cartItems.reduce((acc, item) => {
				if (item.remoteProductId === this.cartItemRemoteProductId) {
					return acc + item.quantity
				}
				return acc
			}, 0)
		},

		productsAmount() {
			const { promotedPrice, price } = this.productDetails
			const hasPromotedPrice =
				promotedPrice !== null && promotedPrice !== undefined
			let amount = hasPromotedPrice ? +promotedPrice : +price

			if (this.selectedForcedMods.length) {
				this.selectedForcedMods.forEach(mod => {
					amount += +mod.price
				})
			}

			return amount * this.productsCount
		},

		subHeaderTop() {
			let top = 62

			const captionHolder = this.$refs['product-details-caption-holder']

			if (captionHolder) {
				const {
					top: captionTop,
					height: captionHeight
				} = captionHolder.getBoundingClientRect()

				top = captionTop + captionHeight + 10
			}

			return top
		},

		subHeaderHeight() {
			return this.$refs['product-details-sub-header'].getBoundingClientRect()
				.height
		},

		acceptOnlineOrder() {
			return this.venueInfo.acceptOnlineOrder
		},

		isToGo() {
			return this.orderType === PRODUCT_ORDER_TYPES.toGo
		},

		isForHere() {
			return this.orderType === PRODUCT_ORDER_TYPES.forHere
		},

		isPickUp() {
			return this.orderType === PRODUCT_ORDER_TYPES.pickUp
		},

		areBadgesEmpty() {
			return (
				!(
					this.productDetails.trending &&
					this.productDetails.trendingCategoryRating &&
					this.isTrending
				) &&
				!this.productDetails.new &&
				!this.productDetails.favorite &&
				!this.isEightySixProduct &&
				!this.limitedQuantity &&
				!this.almostGone
			)
		}
	},

	methods: {
		...mapActions('venue', ['setAllOrderingAvailable']),
		...mapActions('products', [
			'getProductDetails',
			'getProductModifiers',
			'clearProductDetails',
			'clearProductModifiers'
		]),
		...mapActions('cart', [
			'updateCartItem',
			'getCart',
			'updateCart',
			'toggleIsCartRecreated'
		]),
		...mapActions('ui', ['addMainError']),

		setOrderType() {
			const { orderType } = this.cartItem

			if (
				(orderType === PRODUCT_ORDER_TYPES.forHere &&
					!this.isForHereOrderingAvailable) ||
				(orderType === PRODUCT_ORDER_TYPES.toGo &&
					!this.isToGoOrderingAvailable)
			) {
				if (this.isForHereOrderingAvailable) {
					this.orderType = PRODUCT_ORDER_TYPES.forHere

					return
				}
				if (this.isToGoOrderingAvailable) {
					this.orderType = PRODUCT_ORDER_TYPES.toGo

					return
				}
			}

			this.orderType = orderType
		},

		orderTypeName() {
			if (
				(this.isToGo || this.isForHere) &&
				!this.isForHereOrderingAvailable &&
				!this.isToGoOrderingAvailable
			) {
				return ALL_ORDER_TYPES_NAMES.inVenue
			}

			return PRODUCT_ORDER_TYPES_NAMES[this.orderType]
		},

		addAsType(type) {
			this.orderType = type
			this.callUpdateProduct()
			this.closeUnAvailableModal()
		},

		isProductOrderTypeAvailable() {
			this.unAvailableModalProps = { ...DEFAULT_UNAVAILABLE_MODAL_PROPS }
			let isUnAvailable = false
			let actionText = ''
			let orderTypeName = ''
			let action = () => {}

			const isTypeToGoAndUnavailable =
				this.isToGo && !this.isToGoOrderingAvailable
			const isTypeForHereAndUnavailable =
				this.isForHere && !this.isForHereOrderingAvailable
			const isTypePickUpAndUnavailable =
				this.isPickUp && !this.isPickUpOrderingAvailable

			isUnAvailable =
				isTypeToGoAndUnavailable ||
				isTypeForHereAndUnavailable ||
				isTypePickUpAndUnavailable

			if (isUnAvailable) {
				if (isTypeToGoAndUnavailable && this.isForHereOrderingAvailable) {
					actionText = ORDERS_ACTIONS_TEXT_LIST.addAsForHere
					action = () => this.addAsType(PRODUCT_ORDER_TYPES.forHere)
				}

				if (isTypeForHereAndUnavailable && this.isToGoOrderingAvailable) {
					actionText = ORDERS_ACTIONS_TEXT_LIST.addAsToGo
					action = () => this.addAsType(PRODUCT_ORDER_TYPES.toGo)
				}

				orderTypeName = this.orderTypeName()
				const availableHours = this.getCurrentTypeAvailableHours()
				const availablePeriod =
					(availableHours && availableHours.length && availableHours[0]) || {}

				return {
					isUnAvailable,
					actionText,
					action,
					orderType: orderTypeName,
					availablePeriod
				}
			}

			return { isUnAvailable }
		},

		getCurrentTypeAvailableHours() {
			if (this.isToGo) return this.toGoHours
			if (this.isForHere) return this.forHereHours
			if (this.isPickUp) return this.pickUpHours
		},

		closeUnAvailableModal() {
			this.isUnAvailableModalOpen = false
		},

		onModalAction(action) {
			this.closeUnAvailableModal()
			action()
		},

		handleResize() {
			this.$nextTick(() => {
				this.subHeaderHeightInPx = this.$refs['product-details-sub-header']
					? this.$refs['product-details-sub-header'].offsetHeight
					: 0
			})
		},

		handleScroll() {
			const productDetailsHolder = this.$refs['product-details-holder']
			const productDetailsRow = this.$refs['product-details-row']

			if (productDetailsRow && productDetailsHolder) {
				const { bottom: rowBottom } = productDetailsRow.getBoundingClientRect()
				const { top: holderTop } = productDetailsHolder.getBoundingClientRect()

				this.isScrollingThroughRow = rowBottom < holderTop + 25
			}

			const { top: currentSubHeaderTop } = this.$refs[
				'product-details-sub-header'
			].getBoundingClientRect()
			const { top: currentFrameTop } = this.$refs[
				'product-details-frame'
			].getBoundingClientRect()

			if (currentSubHeaderTop < this.subHeaderTop && !this.isStuck) {
				this.addStuck()
			}

			if (
				currentFrameTop > this.subHeaderTop + this.subHeaderHeight &&
				this.isStuck
			) {
				this.removeStuck()
			}
		},

		addStuck() {
			this.isStuck = true

			const productDetailsHeaderWrap = this.$refs['product-details-header-wrap']

			const productDetailsHeaderWrapHeight =
				productDetailsHeaderWrap.offsetHeight
			const stuckTop =
				productDetailsHeaderWrapHeight -
				this.subHeaderTop -
				this.subHeaderHeight

			productDetailsHeaderWrap.style.top = `-${stuckTop}px`
		},

		removeStuck() {
			this.isStuck = false

			this.$refs['product-details-header-wrap'].style.top = 0
		},

		async getData() {
			await this.callGetProductDetails()

			if (!this.hasProductDetailsError) {
				await this.callGetProductModifiers()
			}

			this.$emit('set-has-images', this.hasImages)
			this.$emit('set-product-error', this.hasProductDetailsError)
		},

		async callGetProductDetails() {
			try {
				this.hasProductDetailsError = false
				if (!this.cartItem) {
					return (this.hasProductDetailsError = true)
				}
				await this.getProductDetails(this.cartItem.productId)
			} catch (e) {
				this.hasProductDetailsError = true
				throw e
			}
		},

		async callGetProductModifiers() {
			try {
				if (!this.cartItem) {
					return (this.hasProductDetailsError = true)
				}
				await this.getProductModifiers(this.cartItem.productId)
			} catch (e) {
				this.hasProductDetailsError = true
				throw e
			}
		},

		init() {
			const cartItem = this.cartItem

			if (cartItem) {
				this.productsCount = cartItem.quantity
				this.selectedForcedMods = cartItem.modifiers
				this.productNotice = cartItem.productNotice
			} else {
				this.productsCount = 0
				this.selectedForcedMods = []
				this.productNotice = ''
			}
		},

		reset() {
			this.clearProductDetails()
			this.clearProductModifiers()
			this.productsCount = 1
			this.isProductUpdating = false
			this.hasProductDetailsError = false
			this.selectedForcedMods = []
			this.productNotice = ''
			this.validateForcedMods = 0
			this.invalidForcedModsCategoryIds = []
			this.showForcedModsErrors = false
			this.isLoaded = false
			this.$emit('set-has-images', true)
			this.$emit('set-product-error', false)
		},

		changeForcedMods(forcedMods) {
			this.selectedForcedMods = forcedMods
			this.triggerForceModeValidation()
		},

		changeProductNotice(val) {
			this.productNotice = val
		},

		changeProductsCount(count) {
			this.productsCount = count
		},

		setIsValidForcedMods(val) {
			this.invalidForcedModsCategoryIds = val
		},

		triggerForceModeValidation() {
			this.validateForcedMods = +new Date() //invoke validation in ProductMods
		},

		async callUpdateProduct() {
			this.triggerForceModeValidation()

			this.setAllOrderingAvailable()

			this.$nextTick(() => {
				if (!this.isForcedModsValid) {
					const firstInvalidForcedModsCategoryId = this
						.invalidForcedModsCategoryIds[0]
					const firstInvalidForcedModsCategoryEl = this.$refs[
						'forced-mods-form'
					].$refs[firstInvalidForcedModsCategoryId][0]
					const {
						top: firstInvalidForcedModsCategoryTop
					} = firstInvalidForcedModsCategoryEl.getBoundingClientRect()
					const productDetailsHolder = this.$refs['product-details-holder']
					const scrollTop = productDetailsHolder.scrollTop

					productDetailsHolder.scrollTo({
						left: 0,
						top:
							firstInvalidForcedModsCategoryTop -
							this.subHeaderTop -
							this.subHeaderHeight +
							scrollTop,
						behavior: 'smooth'
					})

					this.showForcedModsErrors = true
				} else {
					this.showForcedModsErrors = false

					const productTypeValidationData = this.isProductOrderTypeAvailable()

					if (productTypeValidationData.isUnAvailable) {
						const {
							actionText,
							action,
							orderType,
							availablePeriod
						} = productTypeValidationData

						this.unAvailableModalProps = {
							...this.unAvailableModalProps,
							actionText,
							action,
							orderType,
							availablePeriod
						}

						this.isUnAvailableModalOpen = true

						return
					}

					this.updateProduct()
				}
			})
		},

		async updateProduct() {
			const forcedModIds = this.selectedForcedMods.map(mod => mod.id)
			const quantity = this.productsCount

			try {
				this.isProductUpdating = true
				await this.updateCartItem({
					cartItemId: this.cartItemId,
					data: {
						venueId: this.venueInfo.id,
						cartId: this.cartId,
						productId: this.cartItemId,
						orderType: this.orderType,
						quantity,
						productNotice: this.productNotice,
						forcedModIds
					}
				})
				this.hideProductDetails()
			} catch (e) {
				this.handleCartError(e)
				this.isProductUpdating = false
			}
		},

		handleCartError(e) {
			const validationCode = getValidationCode(e)
			// TODO: Check logic in the 4.0
			if (UPDATE_CART_ITEM_400_VALIDATION_CODES.includes(validationCode)) {
				this.addMainError('Your cart was updated')
				this.navigateToMainScreen()
			} else if (
				UPDATE_CART_ITEM_404_VALIDATION_CODES.includes(validationCode)
			) {
				this.toggleIsCartRecreated()
				this.$emit('update-cart')
			}
		},

		navigateToMainScreen() {
			this.isProductUpdating = false
			this.hideProductDetails()
			this.goToProducts()
		},

		hideProductDetails() {
			this.$emit('hide')
		},
		isPromotedPriceLess(promotedPrice, price) {
			return Number(promotedPrice) < Number(price)
		}
	}
}
</script>
